import { Component, OnDestroy, OnInit } from '@angular/core';
import { RiskPreference } from '@interfaces/open-choice/risk-preference.model';
import { RiskDescriptionEnum } from '@interfaces/open-choice/risk-quiz.enum';
import { select, Store } from '@ngrx/store';
import { PageComponent } from '@shared/components';
import { replaceWhitespace } from '@shared/helpers';
import { ContentPageId, FlowTypes, urlMapper } from '@shared/models';
import { AEMService } from '@shared/services/aem/aem.service';
import { RiskQuizResultsContent } from '@shared/services/content/content-jsons/risk-quiz-results-content';
import { OpenchoiceRemoteContent } from '@src/aem/models/OpenchoiceRemoteContent';
import {
  RetakeRiskQuiz,
  UpdatePortfolioMatchResult,
} from '@store/actions/open-choice/open-choice.actions';
import * as fromRootStore from '@store/index';
import { LogError } from '@store/index';
import { getFlowTypeSelection } from '@store/reducers/triage/triage.reducer';

import { getRiskAttitude } from '../helper/risk-attitude.helper';
import { toPageContent } from './risk-quiz-results-content-mapper';
@Component({
  selector: 'app-risk-quiz-results',
  templateUrl: './risk-quiz-results.component.html',
  styleUrl: './risk-quiz-results.component.scss',
})
export class RiskQuizResultsComponent
  extends PageComponent<OpenchoiceRemoteContent>
  implements OnInit, OnDestroy
{
  content = RiskQuizResultsContent;
  flow: FlowTypes | null = null;

  isRiskAttitudeValid = false;
  riskAttitude: RiskDescriptionEnum | null = null;

  constructor(
    globalStore: Store<fromRootStore.State>,
    protected aemService: AEMService,
  ) {
    super(ContentPageId.openchoice, globalStore, { aemService, toPageContent });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subs.add(
      this.globalStore.pipe(select(fromRootStore.selectTriageState)).subscribe((triage) => {
        this.flow = getFlowTypeSelection(triage);
      }),
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  riskAttitudeChanged(event: CustomEvent<RiskPreference>): void {
    this.isRiskAttitudeValid = event?.detail?.isValid;
    this.riskAttitude = getRiskAttitude(event?.detail);

    this.globalStore.dispatch(UpdatePortfolioMatchResult({ payload: this.riskAttitude }));
  }

  retakingRiskQuizHandler(): void {
    this.globalStore.dispatch(RetakeRiskQuiz());
  }

  errorHandler(event: CustomEvent): void {
    const errorDetails = JSON.stringify(event.detail);
    this.globalStore.dispatch(
      LogError({
        payload: {
          eventId: 'open-choice-risk-quiz-results--error',
          message: `Risk Quiz Results MFE failed.`,
          errorDetails,
        },
      }),
    );
    this.globalStore.dispatch(fromRootStore.rejectDAOffer());
    this.globalStore.dispatch(fromRootStore.UpdateDAComponentFailure({ payload: true }));
    if (this.flow === FlowTypes.MINOR) {
      this.globalStore.dispatch(
        fromRootStore.Go({ path: [`secure/${urlMapper[this.flow]}/review`] }),
      );
    } else {
      this.globalStore.dispatch(fromRootStore.Go({ path: ['error'] }));
    }
  }

  adobeProcessSideStepSuccess(): void {
    const data = {
      processType: `coo-minor-flow`,
      processSideStep: replaceWhitespace(
        `coo-minor-gc-risk_quiz-results-${this.riskAttitude}`,
        '_',
      ).toLowerCase(),
    };
    this.globalStore.dispatch(fromRootStore.TrackProcessSideStep(data));
  }

  continue(): void {
    if (this.isRiskAttitudeValid) {
      this.globalStore.dispatch(fromRootStore.Next());
      this.adobeProcessSideStepSuccess();
    }
  }
}
